






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Form } from '@ss/mtd-vue';

const urlReg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

const formRule = {
    Announcement: {
        content: {
            required: true,
            message: '必填项'
        }
    },
    RgFaq: {
        title: {
            required: true,
            message: '必填项'
        },
        content: {
            required: true,
            message: '必填URL',
            validator: (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('必填URL'));
                }
                const regex = new RegExp(urlReg);
                if (value.match(regex)) {
                    return callback();
                } else {
                    return callback(new Error('必填URL'));
                }
            }
        }
    }
};

/**
 * 添加RG user
 *
 * @author liyuyao
 * @date 03/22/2020
 */
@Component({
    components: {}
})
export default class RgTemplateModal extends Vue {
    @Prop({ default: false })
    visible: Boolean;

    @Prop()
    type: string;

    @Prop()
    data: any;

    show: Boolean = false;
    formData: any = {};
    formRule: any = {};

    $refs: {
        formModal: Form;
    };

    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
    }
    @Watch('data')
    onChangeData(val) {
        this.formData = val;
    }

    created() {
        this.formRule = formRule[this.type];
    }
    handleReset() {
        this.$refs.formModal.resetFields();
    }

    clearValidationErrors() {
        this.$refs.formModal.clearValidate();
    }

    close() {
        this.$refs.formModal
            .validate(valid => {
                if (valid) {
                    this.show = false;
                    this.$emit(
                        'addItem',
                        Object.assign(this.formData, {
                            rgId: parseInt(this.$route.query.rgId as string, 10)
                        })
                    );
                    this.formData = {};
                }
            })
            .catch(e => e);
    }
    closeModal() {
        this.show = false;
        // this.handleReset(); // 重置表单字段和错误提示
        this.clearValidationErrors(); // 清除表单验证错误信息
        this.$emit('closeModal', false);
    }
}
